import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "AddPermissionModal",
  tabindex: "-1",
  role: "dialog",
  ref: "addPermissionModalRef",
  "aria-labelledby": "tooltipmodal",
  "aria-hidden": "true"
}
const _hoisted_2 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-title" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn-close py-0",
  type: "button",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-md-12 mb-3" }
const _hoisted_10 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Nom "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_12 = { class: "col-md-12 mb-3" }
const _hoisted_13 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Description "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_15 = ["onUpdate:modelValue"]
const _hoisted_16 = {
  class: "btn btn-primary",
  type: "submit"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h4", _hoisted_5, _toDisplayString($setup.title), 1),
          _hoisted_6
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_Form, {
            ref: "permissionForm",
            onSubmit: $setup.addPermission,
            "validation-schema": $setup.permissionSchema
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _createVNode(_component_Field, {
                      name: "nom",
                      type: "text",
                      disabled: $setup.isupdate,
                      class: "form-control shadow-none fs-md-15 text-black",
                      placeholder: "Entrer le nom"
                    }, null, 8, ["disabled"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "nom",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createVNode(_component_Field, {
                      name: "description",
                      cols: "20",
                      rows: "3",
                      as: "textarea",
                      placeholder: "Description",
                      class: "form-control shadow-none rounded-0 text-black"
                    }, {
                      default: _withCtx(({ field }) => [
                        _withDirectives(_createElementVNode("textarea", {
                          "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                          class: "form-control shadow-none rounded-0 text-black"
                        }, null, 8, _hoisted_15), [
                          [_vModelText, field.value]
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "description",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("button", _hoisted_16, _toDisplayString($setup.btntext), 1)
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ])
      ])
    ])
  ], 512))
}